import { authUserData } from ".";
import { Team } from "../my-type";
import {
  type TeamAdminSettingsRequest,
  TeamService as GeneratedTeamService,
  callApi,
  configureApiClient,
} from "../api/client";

const configureTeamApiClient = () => {
  configureApiClient({
    tokenProvider: () => authUserData()?.jwtToken ?? null,
  });
};

export const updateTeamAdminSettings = async (
  request: TeamAdminSettingsRequest
): Promise<Team> => {
  configureTeamApiClient();
  const data = await callApi(
    () => GeneratedTeamService.putApiTeamUpdateAdminSettings(request),
    "更新管理設定失敗"
  );

  return data as unknown as Team;
};
